<script setup>
definePage({
  meta: {
    layout: 'default',
    action: 'manage',
    subject: 'Risk',
  },
})

const page = {
  groupTitle: 'Mutu',
  icon: 'ri-alert-line',
  color: 'error',
  title: 'Risk Register',
  description: 'Mencatat risiko dan menghitung skornya dari kemungkinan × dampak.',
  purpose: 'Panduan mencatat risiko dan memahami cara skor risiko dihitung.',
  concept: [
    {
      icon: 'ri-calculator-line',
      title: 'Skor Risiko = Kemungkinan × Dampak',
      text: 'Anda memberi nilai Kemungkinan (1-5) dan Dampak (1-5) — skor risiko dihitung otomatis dari perkalian keduanya (maksimum 25).',
    },
  ],
  steps: [
    { title: 'Buka menu Mutu → Risk Register, klik "Tambah Risiko"', detail: 'Isi Judul risiko, Deskripsi, Unit terkait, dan Kategori (opsional).' },
    { title: 'Isi nilai Kemungkinan (1-5) dan Dampak (1-5)', detail: 'Skor risiko terhitung otomatis dan tampil langsung sambil Anda mengisi.' },
    { title: 'Isi Rencana Mitigasi', detail: 'Langkah yang akan diambil untuk menurunkan risiko ini.' },
    { title: 'Klik "Simpan"', detail: 'Risiko masuk daftar dan bisa diubah statusnya (diidentifikasi/dimitigasi/ditutup) seiring waktu.' },
  ],
  tips: [
    'Review Risk Register secara berkala (mis. tiap kuartal) — risiko yang statis lama biasanya butuh mitigasi baru.',
    'Fokuskan energi ke risiko dengan skor tertinggi terlebih dulu.',
  ],
  faq: [
    { q: 'Kalau saya update Dampak tapi tidak update Kemungkinan, apa skornya tetap benar?', a: 'Ya — skor dihitung ulang otomatis, mengambil nilai Kemungkinan yang lama kalau tidak Anda ubah.' },
  ],
}
</script>

<template>
  <GuidePageLayout v-bind="page" />
</template>
